const config = {
  autoHideDuration: 2500,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
};

export default config;
